// extracted by mini-css-extract-plugin
export default {"container":"Debug_container__tYooy","testButton":"Debug_testButton__pa5kl","testModal":"Debug_testModal__TxiRQ"};